<script>
    import { createEventDispatcher } from 'svelte';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let community = 'en';
    export let openingText = '';
    export let resultText = '';
    export let direction = 'horizontal';
    export let items = [];
    export let value = null;

    //METHODS
    const chooseVignette = (value, index) => {
        selectedIndex = index;
        dispatch('vignette', value);
    };

    //VARIABLES
    const sortedItems = [...items].sort((a, b) => {
        return (a['index'] || 0) > (b['index'] || 0) ? 1 : ((a['index'] || 0) === (b['index'] || 0) ? 0 : -1);
    });
    let selectedIndex = sortedItems.findIndex(item => item.code === value);
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
{#if selectedIndex === -1}
    <div class="app-msi_opening-text">{@html openingText}</div>
{/if}
<div class={(direction === 'vertical' ? "app-msi_flex-column" : "app-msi_flex-row") + " app-msi_align-items-stretch app-msi_align-content-center app-msi_flex-wrap"}>
    {#each sortedItems as item, i}
        <div class={"app-msi_item" + (i === selectedIndex ? ' app-msi_item-selected' : '')} on:click={() => {
            chooseVignette(item.code, i);
        }}>
            <div class="app-msi_item-image">
                <img src={item.source} alt={item.code}>
            </div>
            <div class="app-msi_item-title">{(item.title.find(value => value.language === community) || {value: ''}).value}</div>
            <div class="app-msi_item-description">{(item.description.find(value => value.language === community) || {value: ''}).value}</div>
        </div>
    {/each}
</div>
{#if selectedIndex >= 0}
    <div class="app-msi_result-text">{@html resultText}</div>
{/if}